"use strict";
var protobuf = module.exports = require(19);

protobuf.build = "full";

// Parser
protobuf.tokenize         = require(36);
protobuf.parse            = require(28);
protobuf.common           = require(13);

// Configure parser
protobuf.Root._configure(protobuf.Type, protobuf.parse, protobuf.common);
